<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش دیکته</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/dictation/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت دیکته جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                item-key="id"
                :headers="headers"
                :items="dictations.data"
                :items-per-page="10"
                disable-sort
                expand-icon="mdi-chevron-up"
                hide-default-footer>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="info" @click="$router.push('/dictation/copy/'+item.id)">mdi-content-copy</v-icon>
                <v-icon class="mx-1" color="purple" @click="$router.push('/dictation/edit/'+item.id)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
              <template
                  v-slot:[`item.cover_file`]="{ item }">
                <img :src="item.cover_file" height="150" width="150" :alt="item.title">
              </template>
              <template
                  v-slot:[`item.file`]="{ item }">
                <audio :src="item.file" controls />
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="dictations.current_page"
                :length="dictations.last_page"
                circle
                @input="getDictations"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            آیا از حذف این دیکته اطمینان دارید؟
          </v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="finalDestroy">
              بله
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" @click="deleteDialog=false">
              خیر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DictationIndex",
  data() {
    return {
      loading: true,
      dictations: {
        current_page: 1
      },
      selectedEntityId: null,
      deleteDialog: false,
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
        {text: 'لیبل', value: 'label', align: 'center', width: '2%'},
        {text: 'نام دسته بندی', value: 'category_name', align: 'center', width: '10%'},
        {text: 'نمایش', value: 'visibility', align: 'center', width: '2%'},
        {text: 'عنوان', value: 'title', align: 'center', width: '2%'},
        {text: 'اولویت', value: 'order', align: 'center', width: '2%'},
        {text: 'کاور', value: 'cover_file', align: 'center', width: '2%'},
        {text: 'فایل', value: 'file', align: 'center', width: '2%'},
        {text: 'نوع', value: 'type', align: 'center', width: '10%'},
        {text: 'عملیات', value: 'operation', align: 'center', width: '15%'},
      ],
    }
  },
  mounted() {
    this.getDictations()
  },
  methods: {
    getDictations() {
      let url = '/course/dictation/index?page=' + this.dictations.current_page ?? 1
      window.axios.get(url).then((res) => {
        this.dictations = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    finalDestroy() {
      window.axios.delete('course/dictation/delete/' + this.selectedEntityId).then(() => {
        this.getDictations()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.deleteDialog = false
      })
    },
    destroy(courseId) {
      this.selectedEntityId = courseId
      this.deleteDialog = true
    }
  }
}
</script>


<style scoped>

</style>
